import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet";
import i18n from "i18next";

const Title: React.FC = () => {
	const { t } = useTranslation();
	const lang = i18n.language;
	
	return (
		<Helmet 
			defaultTitle={t('browser_title')}
			htmlAttributes={{lang, translate:'no'}}
		/>
	);
};
export default Title;
